var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.771 1V1C11.511 1 14.542 4.031 14.542 7.771V7.771C14.542 11.511 11.511 14.542 7.771 14.542V14.542C4.031 14.542 1 11.511 1 7.771V7.771C1 4.031 4.031 1 7.771 1Z",
    stroke: "#FC0167",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77344 8.14772V4.38672",
    stroke: "#FC0167",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77244 10.8187C7.68944 10.8187 7.62244 10.8858 7.62344 10.9688C7.62344 11.0517 7.69044 11.1187 7.77344 11.1187C7.85644 11.1187 7.92344 11.0517 7.92344 10.9688C7.92344 10.8867 7.85644 10.8187 7.77244 10.8187",
    stroke: "#FC0167",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertCircle);
export default __webpack_public_path__ + "static/media/ic_alert_circle.aa429fde31778f3f3edf8a00541528bb.svg";
export { ForwardRef as ReactComponent };